<template>
    <guest-layout>
        <div class="form-col mh-100">
            <div class="arrow-back d-none d-lg-block">
                <a :href="route('home')"><span><i class="feather-chevron-left"></i></span>Back to login</a>
            </div>
            <div class="web-form">
                <div class="title-col">
                    <h2>Create new password</h2>
                    <p>Type in your new password</p>
                </div>
                <form class="form-style" @submit.prevent="submit">
                    <jet-validation-errors class="mb-4" />
                    <div class="form-group">
                        <label class="label-style" for="pwdFld">New password*</label>
                        <div class="input-col space-input">
                            <input v-bind:type="[showPassword ? 'text' : 'password']" id="password" type="password" class="form-control input-style" v-model="form.password" autocomplete="new-password">

                            <div v-if="form.errors.password" v-bind:style="styleObject">{{ form.errors.password }}</div>

                            <button type="button" class="show-hide-class" @click="showPassword = !showPassword">show</button>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="label-style" for="pwdFld">Confirm Password*</label>
                        <div class="input-col space-input">
                            <input v-bind:type="[confirm_showPassword ? 'text' : 'password']" id="password_confirmation" type="password" class="form-control input-style" v-model="form.password_confirmation" required autocomplete="new-password">

                            <div v-if="form.errors.password" v-bind:style="styleObject">{{ form.errors.password }}</div>

                            <button type="button" class="show-hide-class" @click="confirm_showPassword = !confirm_showPassword">show</button>
                        </div>
                    </div>
                    <div class="form-group pt-4">
                        <button type="submit" class="btn btn-style btn-primary w-100" :disabled="form.processing"><span>Set password</span></button>
                    </div>
                </form>
            </div>
        </div>
    </guest-layout>
</template>

<script>

    import GuestLayout from "@/Layouts/GuestLayout";
    import JetValidationErrors from '@/Jetstream/ValidationErrors'
    export default {
        components: {
            GuestLayout,
            JetValidationErrors
        },

        props: {
            email: String,
            token: String,
        },

        data() {
            return {
                form: this.$inertia.form({
                    token: this.token,
                    email: this.email,
                    password: '',
                    password_confirmation: '',
                }),
                styleObject: {
                    color: 'red',
                    fontSize: '15px'
                },
                showPassword: false,
                confirm_showPassword:false,
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('password.update'), {
                    onFinish: () => this.form.reset('password', 'password_confirmation'),
                })
            }
        }
    }
</script>
